import type {Emitter} from 'mitt'

import mitt from 'mitt'

export type Events = {
    user_order_submit: unknown
    user_order_cancel: unknown
    user_order_received: unknown
    user_order_not_received: unknown
    user_order_undo: unknown
    user_order_hide: unknown
    user_order_transfer: unknown
    user_constraints_fetch: unknown
    user_constraints_fetch_cart: unknown
    user_impersonation_order_cancel: unknown
    user_impersonation_order_received: unknown
    user_impersonation_order_undo: unknown
    user_cart_change: unknown
    grouping_product_before_load: unknown
    grouping_products_before_load: unknown
    grouping_product_after_load: unknown
    grouping_products_after_load: unknown
}

export const emitter: Emitter<Events> = mitt<Events>()

export default emitter;